import React from 'react'

import { useTranslation } from 'react-i18next'

import {
  Box,
  ProgressRange,
  ProgressRoot,
  ProgressTrack,
  Stack,
  Text,
} from '@enechain/ecloud-designsystem'

type Props = {
  progress: number
}

export const SimulationProgressing: React.FC<Props> = ({ progress }) => {
  const { t } = useTranslation(['page'])

  return (
    <Stack
      backgroundColor="Surface.secondary"
      paddingX="8"
      paddingTop="8"
      paddingBottom="12"
      borderRadius="radiiXl"
      alignItems="center"
      justifyContent="center"
      gap="6"
    >
      <Text textStyle="headerSm" color="Text.midEmphasis">
        {t('page:simulation.simulation_progressing')}
      </Text>
      <Box width="240px">
        <ProgressRoot value={progress} size="sm" borderRadius="radiiFull">
          <ProgressTrack height="16px">
            <ProgressRange backgroundColor="Object.accentPrimary" />
          </ProgressTrack>
        </ProgressRoot>
      </Box>
    </Stack>
  )
}
